import { cn } from '@/shared/lib/cn';

/** Simbolo oficial da SeguraCore, derivado de brand/logo-symbol.png. */
export const SIMBOLO_OFICIAL = '/brand/logo-symbol.png';

/** Marca horizontal oficial, para fundo claro: o texto da marca e azul escuro. */
export const LOGO_HORIZONTAL_OFICIAL = '/brand/logo-horizontal.png';

/**
 * Simbolo da aplicacao.
 *
 * Quando a empresa possui identidade propria, a imagem enviada por ela substitui
 * a marca padrao. Sem imagem, vale o simbolo oficial da SeguraCore. Antes havia aqui
 * um "S" desenhado, que nao era a marca e aparecia no menu e na tela de acesso.
 */
export function LogoSymbol({
  size = 32,
  src,
  alt,
  className,
}: {
  size?: number;
  src?: string;
  alt?: string;
  className?: string;
}) {
  return (
    <img
      src={src || SIMBOLO_OFICIAL}
      alt={alt ?? ''}
      width={size}
      height={size}
      className={cn('shrink-0 object-contain', src ? 'rounded-md' : null, className)}
    />
  );
}

/** Marca horizontal oficial, com o nome e a assinatura. So para fundo claro. */
export function LogoHorizontal({
  height = 40,
  className,
}: {
  height?: number;
  className?: string;
}) {
  return (
    <img
      src={LOGO_HORIZONTAL_OFICIAL}
      alt="SeguraCore"
      height={height}
      style={{ height }}
      className={cn('w-auto object-contain', className)}
    />
  );
}

export function LogoLockup({
  name = 'SeguraCore',
  tagline,
  symbolSrc,
  className,
}: {
  name?: string;
  tagline?: string;
  symbolSrc?: string;
  className?: string;
}) {
  return (
    <div className={cn('flex items-center gap-2.5', className)}>
      {symbolSrc ? (
        <LogoSymbol size={34} src={symbolSrc} alt="" />
      ) : (
        <LogoSymbol size={34} />
      )}
      <span className="flex min-w-0 flex-col leading-tight">
        <span className="truncate text-[0.9375rem] font-semibold text-white">
          {name}
        </span>
        {tagline ? (
          <span className="truncate text-[0.625rem] tracking-wide text-white/55 uppercase">
            {tagline}
          </span>
        ) : null}
      </span>
    </div>
  );
}
